"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "f706477",
    "raw": "v2.6.2",
    "semverString": "2.6.2"
};
//# sourceMappingURL=version.js.map